// import React, { useState, useEffect } from 'react';
// import { Modal, Offcanvas } from 'react-bootstrap';
// import Select from 'react-select';

// const ProductForm = ({
//     showModal,
//     handleClose,
//     productId,
//     productData,
//     addProduct,
//     vendors,
//     fetchVendors,
//     fetchBrands,
//     editProduct,

//     fetchCategories,
//     setupIdError,
//     products,
//     categories,
//     brands,
// }) => {
//     const [formData, setFormData] = useState({
//         product_type: 'single',
//         product_name: '',
//         product_sku: '',
//         alert_quantity: '',
//         product_image: '',
//         purchase_price: '',
//         selling_price: '',
//         min_selling_price: '',
//         price_of_other_currency: '',
//         tax: '',
//         tax_type: '',
//         category_id: '',
//         subcategory_id: '',
//         unit: '',
//         brand_id: '',
//         hourly_rate: '',
//         inhouse: '',
//         vendor_id: '',
//         description: '',
//         revenue_type: 'deferred', // Default revenue_type for new products
//     });

//     const [vendorCurrency, setVendorCurrency] = useState("AED");

//     const AED_TO_USD = 1 / 3.67;

//     const convertToUSD = (value) => {
//         return (value * AED_TO_USD).toFixed(2); // Convert USD to AED and round to two decimal places
//     };
//     const USD_TO_AED = 3.67; // Conversion rate from USD to AED


//     // Convert USD to AED for saving
//     const convertToAED = (value) => (value * USD_TO_AED).toFixed(2);
//     const getConvertedPrice = (fieldValue) => {
//         if (formData.inhouse === "1") {
//             return fieldValue; // No conversion for in-house
//         }

//         if (formData.inhouse === "0" && vendorCurrency === "USD") {
//             return convertToUSD(fieldValue); // Convert to AED for outsourced with USD vendor
//         }

//         return fieldValue; // Return the value as is for outsourced with AED vendor
//     };
//     const [loadingBrands, setLoadingBrands] = useState(false);
//     const [loadingVendors, setLoadingVendors] = useState(false);
//     const [loadingCategories, setLoadingCategories] = useState(false);

//     useEffect(() => {
//         if (showModal) {
//             if (!loadingCategories && categories.allCategoriesList.length === 0) {
//                 setLoadingCategories(true);
//                 fetchCategories().finally(() => setLoadingCategories(false)); // Fetch categories only if not loaded
//             }

//             if (!loadingBrands && brands.allBrands.length === 0) {
//                 setLoadingBrands(true);
//                 fetchBrands().finally(() => setLoadingBrands(false)); // Fetch brands only if not loaded
//             }

//             if (!loadingVendors && vendors.allVendors.length === 0) {
//                 setLoadingVendors(true);
//                 fetchVendors().finally(() => setLoadingVendors(false)); // Fetch vendors only if not loaded
//             }
//         }
//     }, [showModal, categories.allCategoriesList.length, brands.allBrands.length, vendors.allVendors.length]);
//     const [errors, setErrors] = useState({});




// useEffect(() => {
//     if (showModal) {
//         console.log("🔥 useEffect triggered");
//         console.log("productData", productData);
//         console.log("categories.allCategoriesList", categories.allCategoriesList);

//         if (productData) {
//             // ✅ Access categories safely (handles productData.Data or direct)
//             const categoriesData = productData.Data?.categories || productData.categories || [];

//             const selectedCategories = Array.isArray(categoriesData)
//                 ? categoriesData.map(cat => ({
//                       value: cat.id,
//                       label: cat.name,
//                   }))
//                 : [];

//             // ✅ Extract dynamic pricing fields from pricings array
//             const pricingsData = productData.Data?.pricings || productData.pricings || [];
//             const dynamicPricingFields = {};
//             if (Array.isArray(pricingsData)) {
//                 pricingsData.forEach(price => {
//                     const model = price.license_model?.toLowerCase();
//                     if (model) {
//                         dynamicPricingFields[`${model}_price`] = price.price || '';
//                         dynamicPricingFields[`${model}_deployment_cost`] = price.deployment_cost || '';
//                         dynamicPricingFields[`${model}_min_price`] = price.min_price || '';
//                     }
//                 });
//             }

//             // ✅ Set all form fields
//             setFormData({
//                 product_name: productData.Data?.product_name || productData.product_name || '',
//                 product_type: productData.Data?.product_type || productData.product_type || 'single',
//                 product_sku: productData.Data?.product_sku || productData.product_sku || '',
//                 alert_quantity: productData.Data?.alert_quantity || productData.alert_quantity || '',
//                 product_image: productData.Data?.product_image || productData.product_image || '',
//                 purchase_price: productData.Data?.purchase_price || productData.purchase_price || '',
//                 selling_price: productData.Data?.selling_price || productData.selling_price || '',
//                 min_selling_price: productData.Data?.min_selling_price || productData.min_selling_price || '',
//                 price_of_other_currency:
//                     productData.Data?.price_of_other_currency || productData.price_of_other_currency || '',
//                 tax: productData.Data?.tax || productData.tax || '',
//                 tax_type: productData.Data?.tax_type || productData.tax_type || '',
//                 category_id: selectedCategories.map(cat => cat.value), // ✅ [45, 46]
//                 subcategory_id: productData.Data?.subcategory_id || productData.subcategory_id || '',
//                 unit: productData.Data?.unit || productData.unit || '',
//                 brand_id: productData.Data?.brand_id || productData.brand_id || '',
//                 hourly_rate: productData.Data?.hourly_rate || productData.hourly_rate || '',
//                 inhouse: productData.Data?.inhouse || productData.inhouse || '',
//                 vendor_id: productData.Data?.vendor_id || productData.vendor_id || '',
//                 description: productData.Data?.description || productData.description || '',
//                 revenue_type: productData.Data?.revenue_type || productData.revenue_type || '',
//                 ...dynamicPricingFields,
//             });

//             // ✅ Prefill vendor currency if applicable
//             const vendorId = productData.Data?.vendor_id || productData.vendor_id;
//             const inhouse = productData.Data?.inhouse || productData.inhouse;

//             if (inhouse === '0' && vendorId) {
//                 const selectedVendor = vendors.allVendors.find(
//                     vendor => String(vendor.id) === String(vendorId)
//                 );
//                 if (selectedVendor) setVendorCurrency(selectedVendor.currency);
//             }
//         } else {
//             // Reset form for Add mode
//             setFormData({
//                 product_type: 'single',
//                 product_name: '',
//                 product_sku: '',
//                 alert_quantity: '',
//                 product_image: '',
//                 purchase_price: '',
//                 selling_price: '',
//                 min_selling_price: '',
//                 price_of_other_currency: '',
//                 tax: '',
//                 tax_type: '',
//                 category_id: [],
//                 subcategory_id: '',
//                 unit: '',
//                 brand_id: '',
//                 hourly_rate: '',
//                 inhouse: '',
//                 vendor_id: '',
//                 description: '',
//                 revenue_type: 'deferred',
//             });
//             setVendorCurrency('');
//         }
//     }
// }, [showModal, productData, vendors]);



//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         if (name === "product_type") {
//             // Automatically set revenue_type based on product_type
//             setFormData((prevState) => ({
//                 ...prevState,
//                 product_type: value,
//                 revenue_type: value === 'single' ? 'deferred' : 'immediate'
//             }));
//             return;
//         }

//         if (name === "vendor_id") {
//             const selectedVendor = vendors.allVendors.find(
//                 (vendor) => String(vendor.id) === String(value)
//             );
//             const newCurrency = selectedVendor ? selectedVendor.currency : "AED";

//             setFormData((prevState) => {
//                 let updatedData = { ...prevState, vendor_id: value };

//                 // Update vendor name in the formData
//                 if (selectedVendor) {
//                     updatedData.vendor_name = selectedVendor.name; // Ensure vendor name updates
//                 }

//                 // Convert price only if the currency is actually changing
//                 if (vendorCurrency !== newCurrency) {
//                     if (vendorCurrency === "AED" && newCurrency === "USD") {
//                         updatedData.purchase_price = convertToUSD(prevState.purchase_price);
//                         updatedData.selling_price = convertToUSD(prevState.selling_price);
//                         updatedData.min_selling_price = convertToUSD(prevState.min_selling_price);
//                     } else if (vendorCurrency === "USD" && newCurrency === "AED") {
//                         updatedData.purchase_price = convertToAED(prevState.purchase_price);
//                         updatedData.selling_price = convertToAED(prevState.selling_price);
//                         updatedData.min_selling_price = convertToAED(prevState.min_selling_price);
//                     }
//                 }

//                 return updatedData;
//             });

//             setVendorCurrency(newCurrency);
//         } else {
//             setFormData((prevState) => ({
//                 ...prevState,
//                 [name]: value,
//             }));
//         }
//     };


//     const getPriceLabel = (fieldName) => {
//         if (formData.inhouse === "1") {
//             return `${fieldName} (AED)`; // In-house products have AED prices
//         }

//         if (formData.inhouse === "0" && vendorCurrency) {
//             return `${fieldName} (${vendorCurrency})`; // Outsourced products with vendor currency
//         }

//         return `${fieldName}`; // Default to AED if no specific condition matches
//     };

//     useEffect(() => {
//         if (!showModal) {
//             setErrors({});
//         }
//     }, [showModal]);

//     const validateForm = () => {
//         const newErrors = {};

//         if (!formData.product_name) {
//             newErrors.product_name = 'Name is required';
//         }

//         if (formData.product_type === 'single') {
//             if (!formData.purchase_price) newErrors.purchase_price = 'Purchase Price is required';
//             if (!formData.selling_price) newErrors.selling_price = 'Selling Price is required';
//             if (!formData.min_selling_price) newErrors.min_selling_price = 'Min Selling Price is required';
//             if (!formData.inhouse) newErrors.inhouse = 'Product source is required';
//         }

//         return newErrors;
//     };

//     const [loading, setLoading] = useState(false);



//     const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     const validationErrors = validateForm();
//     if (Object.keys(validationErrors).length > 0) {
//         setErrors(validationErrors);
//         setLoading(false);
//         return;
//     }

//     const dataToSend = { ...formData };

//     // ✅ Ensure category_id is an array
//     if (!Array.isArray(dataToSend.category_id)) {
//         dataToSend.category_id = dataToSend.category_id
//             ? [Number(dataToSend.category_id)]
//             : [];
//     }

//     // ✅ If no categories selected, ensure empty array
//     dataToSend.category_id = dataToSend.category_id || [];

//     // ✅ Build pricings array from selected categories
//     const selectedCategories = categories?.allCategoriesList?.filter(cat =>
//         dataToSend.category_id.includes(cat.id)
//     ) || [];

//     dataToSend.pricings = selectedCategories.map(cat => {
//         const model = cat.name.toLowerCase();
//         return {
//             license_model: model,
//             price: Number(formData[`${model}_price`] || 0),
//             deployment_cost: Number(formData[`${model}_deployment_cost`] || 0),
//             min_price: Number(formData[`${model}_min_price`] || 0),
//         };
//     });

//     // ✅ Clean up dynamic pricing fields
//     selectedCategories.forEach(cat => {
//         const model = cat.name.toLowerCase();
//         delete dataToSend[`${model}_price`];
//         delete dataToSend[`${model}_deployment_cost`];
//         delete dataToSend[`${model}_min_price`];
//     });

//     // ✅ Send to API (arrays handled inside addProduct)
//     let apierrors;
//     try {
//         if (productData) {
//             apierrors = await editProduct(productData.id, dataToSend);
//         } else {
//             apierrors = await addProduct(dataToSend);
//         }
//     } catch (err) {
//         console.error(err);
//         setLoading(false);
//         return;
//     }

//     if (apierrors) {
//         setErrors(apierrors);
//     } else {
//         setErrors({});
//         handleClose();
//         localStorage.setItem("productFormData", JSON.stringify(dataToSend));
//     }

//     setLoading(false);
// };


//     const handleFileChange = (e) => {
//         const file = e.target.files[0];
//         if (file) {
//             // Update the formData with the selected file under 'avatar' field
//             setFormData((prevData) => ({
//                 ...prevData,
//                 product_image: file,  // Ensure this is 'avatar' and not 'profile_picture'
//             }));
//         }
//     };


//     const handleCategoryChange = (selectedOptions) => {
//         const selectedIds = selectedOptions ? selectedOptions.map((opt) => opt.value) : [];
//         const selectedLabels = selectedOptions ? selectedOptions.map((opt) => opt.label.toLowerCase()) : [];

//         let product_type = "single";
//         let revenue_type = "deferred";

//         // Apply logic based on selected license types
//         if (selectedLabels.includes("perpetual")) {
//             product_type = "service";
//             revenue_type = "immediate";
//         } else if (selectedLabels.includes("subscription") || selectedLabels.includes("hybrid")) {
//             product_type = "single";
//             revenue_type = "deferred";
//         }

//         // Update form data
//         setFormData((prev) => ({
//             ...prev,
//             category_id: selectedIds, // send only IDs to backend
//             product_type,
//             revenue_type,
//         }));
//     };



//     // const renderDynamicLicenseFields = () => {
//     //     // get selected category names dynamically
//     //     const selectedCategories = categories?.allCategoriesList?.filter(cat =>
//     //         formData.category_id?.includes(cat.id)
//     //     ) || [];

//     //     return selectedCategories.map((cat) => {
//     //         const model = cat.name.toLowerCase();
//     //         return (
//     //             <div key={model}>

//     //                 <div className="col-md-6">
//     //                     <div className="form-group mb-3">

//     //                         <label style={{ fontSize: "13px" }}>{model} Price</label>
//     //                         <input
//     //                             type="number"
//     //                             name={`${model}_price`}
//     //                             value={formData[`${model}_price`] || ""}
//     //                             onChange={handleChange}
//     //                             className="form-control"
//     //                             style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}


//     //                         />
//     //                     </div>
//     //                 </div>

//     //                 <div className="col-md-6">
//     //                     <div className="form-group mb-3">

//     //                         <label style={{ fontSize: "13px" }}>{model} Deployment Cost</label>
//     //                         <input
//     //                             type="number"
//     //                             name={`${model}_deployment_cost`}
//     //                             value={formData[`${model}_deployment_cost`] || ""}
//     //                             onChange={handleChange}
//     //                             className="form-control"
//     //                             style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}

//     //                         />
//     //                     </div>
//     //                 </div>

//     //                 <div className="col-md-6">
//     //                     <div className="form-group mb-3">

//     //                         <label style={{ fontSize: "13px" }}>Min {model} Price (AED)</label>
//     //                         <input
//     //                             type="number"
//     //                             name={`${model}_min_price`}
//     //                             value={formData[`${model}_min_price`] || ""}
//     //                             onChange={handleChange}
//     //                             className="form-control"
//     //                             style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}

//     //                         />
//     //                     </div>
//     //                 </div>
//     //             </div>
//     //         );
//     //     });
//     // };

//     const renderDynamicLicenseFields = () => {
//         // Safely get selected categories
//         const selectedCategories =
//             categories?.allCategoriesList?.filter(
//                 (cat) => Array.isArray(formData.category_id) && formData.category_id.includes(cat.id)
//             ) || [];

//         // ✅ Make sure key is unique and stable
//         return selectedCategories.map((cat) => {
//             const model = cat.name?.toLowerCase().trim();
//             return (
//                 <React.Fragment key={`${cat.id}-${model}`}>
//                     <div className="col-md-6">
//                         <div className="form-group mb-3">
//                             <label style={{ fontSize: "13px" }}>{model} Price</label>
//                             <input
//                                 type="number"
//                                 name={`${model}_price`}
//                                 value={formData[`${model}_price`] || ""}
//                                 onChange={handleChange}
//                                 className="form-control"
//                                 style={{
//                                     fontSize: "13px",
//                                     maxWidth: "280px",
//                                     borderRadius: "14px",
//                                     height: "35px",
//                                     border: "0.5px solid rgb(232, 233, 237)",
//                                 }}
//                             />
//                         </div>
//                     </div>

//                     <div className="col-md-6">
//                         <div className="form-group mb-3">
//                             <label style={{ fontSize: "13px" }}>{model} Deployment Cost</label>
//                             <input
//                                 type="number"
//                                 name={`${model}_deployment_cost`}
//                                 value={formData[`${model}_deployment_cost`] || ""}
//                                 onChange={handleChange}
//                                 className="form-control"
//                                 style={{
//                                     fontSize: "13px",
//                                     maxWidth: "280px",
//                                     borderRadius: "14px",
//                                     height: "35px",
//                                     border: "0.5px solid rgb(232, 233, 237)",
//                                 }}
//                             />
//                         </div>
//                     </div>

//                     <div className="col-md-6">
//                         <div className="form-group mb-3">
//                             <label style={{ fontSize: "13px" }}>Min {model} Price</label>
//                             <input
//                                 type="number"
//                                 name={`${model}_min_price`}
//                                 value={formData[`${model}_min_price`] || ""}
//                                 onChange={handleChange}
//                                 className="form-control"
//                                 style={{
//                                     fontSize: "13px",
//                                     maxWidth: "280px",
//                                     borderRadius: "14px",
//                                     height: "35px",
//                                     border: "0.5px solid rgb(232, 233, 237)",
//                                 }}
//                             />
//                         </div>
//                     </div>
//                 </React.Fragment>
//             );
//         });
//     };

//     return (
//         <Offcanvas show={showModal} onHide={handleClose} placement='end' style={{ width: '690px' }}>
//             <Offcanvas.Header closeButton>
//                 <Offcanvas.Title>{productId ? 'Edit Product' : 'Add Product'}</Offcanvas.Title>
//             </Offcanvas.Header>
//             <hr style={{ margin: 0 }} />

//             <Offcanvas.Body>
//                 <form>
//                     <div className="row">
//                         {/* <div className="col-md-6">
//                             <div className="form-group mb-3">
//                                 <label htmlFor="product_type" className="form-label" style={{ fontSize: "13px" }}>Product Type:</label>
//                                 <select
//                                     style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                     name="product_type"
//                                     id="product_type"
//                                     className={`form-control ${errors.product_type ? 'is-invalid' : ''}`}
//                                     value={formData.product_type}
//                                     onChange={handleChange}
//                                 >

//                                     <option value="single">Subscription</option>
//                                     <option value="service">Professional Service</option>
//                                     <option value="one-time"> One-Time</option>

//                                 </select>
//                                 {errors.product_type && (
//                                     <div className="invalid-feedback" style={{ fontSize: "13px" }}>
//                                         {errors.product_type[0]}
//                                     </div>
//                                 )}
//                             </div>
//                         </div> */}
//                         <div className="col-md-6">

//                             <div className="form-group mb-3">
//                                 <label htmlFor="brand_id" style={{ fontSize: "13px" }}>Brand</label>
//                                 <select
//                                     style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                     id="brand_id"
//                                     name="brand_id"
//                                     value={formData.brand_id}
//                                     onChange={handleChange}
//                                     className="form-control"
//                                 >
//                                     <option value="">Select a Brand</option>
//                                     {brands?.allBrands?.map((brand) => (
//                                         <option key={brand.id} value={brand.id}>
//                                             {brand.name}
//                                         </option>
//                                     ))}
//                                 </select>
//                             </div></div>
//                         <div className="col-md-6">

//                             <div className="form-group mb-3">
//                                 <label htmlFor="category_id" style={{ fontSize: "13px" }}>Type:</label>
//                                 <Select
//                                     id="category_id"
//                                     name="category_id"
//                                     isMulti
//                                     options={
//                                         categories?.allCategoriesList?.map((cat) => ({
//                                             value: cat.id,
//                                             label: cat.name,
//                                         })) || []
//                                     }
//                                     // value={
//                                     //     formData.category_id && Array.isArray(formData.category_id)
//                                     //         ? categories?.allCategoriesList
//                                     //             ?.filter((cat) => formData.category_id.includes(cat.id))
//                                     //             .map((cat) => ({ value: cat.id, label: cat.name }))
//                                     //         : []
//                                     // }
//                                     value={
//   categories?.allCategoriesList
//     ?.filter(cat => formData.category_id?.includes(cat.id))
//     .map(cat => ({ value: cat.id, label: cat.name })) || []
// }

//                                     onChange={handleCategoryChange}
//                                     styles={{
//                                         control: (provided) => ({
//                                             ...provided,
//                                             fontSize: '13px',
//                                             maxWidth: '280px',
//                                             borderRadius: '14px',
//                                             minHeight: '35px',
//                                             border: '0.5px solid rgb(232, 233, 237)',
//                                         }),
//                                         multiValue: (provided) => ({
//                                             ...provided,
//                                             borderRadius: '10px',
//                                             backgroundColor: '#f1f1f1',
//                                         }),
//                                     }}
//                                     placeholder="Select category"
//                                 />
//                             </div>

//                         </div>
//                     </div>
//                     <div className="row">
//                         <div className="col-md-6">
//                             <div className="form-group mb-3">
//                                 <label htmlFor="product_name" style={{ fontSize: "13px" }} className="form-label">Product Name:</label>
//                                 <input
//                                     style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                     type="text"
//                                     name="product_name"
//                                     id="product_name"
//                                     className={`form-control ${errors.product_name ? 'is-invalid' : ''}`}
//                                     value={formData.product_name}
//                                     onChange={handleChange}
//                                 />
//                                 {errors.product_name && <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.product_name}</div>}

//                             </div>
//                         </div>



//                         <div className="col-md-6">
//                             <div className="form-group mb-3">
//                                 <label htmlFor="unit" style={{ fontSize: "13px" }}>Unit:</label>
//                                 <select
//                                     style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                     name="unit"
//                                     id="unit"
//                                     className='form-control'
//                                     value={formData.unit}
//                                     onChange={handleChange}
//                                 >
//                                     <option value="">Select Unit</option>
//                                     <option value="qty">QTY</option>
//                                     <option value="man-days">MAN-DAYS</option>


//                                 </select>

//                             </div>
//                         </div>

//                     </div>
//                     <div className="row">
//                         <div className="col-md-6">
//                             <div className="form-group mb-3">
//                                 <label style={{ fontSize: "13px" }} htmlFor="product_sku" className="form-label">Product Sku:</label>
//                                 <input
//                                     style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                     type="text"
//                                     name="product_sku"
//                                     id="product_sku"
//                                     className="form-control"
//                                     value={formData.product_sku}
//                                     onChange={handleChange}

//                                 />

//                             </div>
//                         </div>

//                         <div className="col-md-6">
//                             <div className="form-group mb-3">
//                                 <label htmlFor="alert_quantity" style={{ fontSize: "13px" }} className="form-label">Alert Quantity:</label>
//                                 <input
//                                     style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                     type="text"
//                                     name="alert_quantity"
//                                     id="alert_quantity"
//                                     className="form-control"
//                                     value={formData.alert_quantity}
//                                     onChange={handleChange}
//                                     required
//                                 />
//                             </div>
//                         </div>
//                     </div>
//                     <div className="row">

//                         <div className="col-md-6">
//                             <div className="form-group mb-3">
//                                 <label htmlFor="inhouse" style={{ fontSize: "13px" }}>Product Source</label>
//                                 <select
//                                     style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                     name="inhouse"
//                                     id="inhouse"
//                                     className={`form-control ${errors.inhouse ? 'is-invalid' : ''}`}
//                                     value={formData.inhouse}
//                                     onChange={handleChange}
//                                 >
//                                     <option value="">Select Source</option>
//                                     <option value='1'>Inhouse</option>
//                                     <option value='0'>Outsource</option>
//                                 </select>
//                                 {errors.inhouse && <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.inhouse}</div>}

//                             </div>
//                         </div>

//                         {/* Render the Vendor dropdown only if 'Outsource' is selected */}
//                         {formData.inhouse === '0' && (
//                             <div className="col-md-6 ">
//                                 <div className="form-group mb-3">
//                                     <label htmlFor="vendor_id" style={{ fontSize: "13px" }}>Select Vendor</label>
//                                     <select
//                                         style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                         name="vendor_id"
//                                         id="vendor_id"
//                                         className="form-control"
//                                         value={formData.vendor_id}
//                                         onChange={handleChange}
//                                     >
//                                         <option value="">Select Vendor</option>
//                                         {vendors?.allVendors?.map((vendor) => (
//                                             <option key={vendor.id} value={vendor.id}>
//                                                 {vendor.name}
//                                             </option>
//                                         ))}
//                                     </select>
//                                 </div>
//                             </div>
//                         )}



//                         {/* <div className="row"> */}


//                         <div className="col-md-6">
//                             <div className="form-group mb-3">
//                                 <label htmlFor="purchase_price" style={{ fontSize: "13px" }} className="form-label">{getPriceLabel("Purchase Price")}
//                                 </label>
//                                 <input
//                                     style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                     type="number"
//                                     name="purchase_price"
//                                     id="purchase_price"
//                                     className={`form-control ${errors.purchase_price ? 'is-invalid' : ''}`}
//                                     value={formData.purchase_price}
//                                     onChange={handleChange}

//                                 />
//                                 {errors.purchase_price && <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.purchase_price}</div>}

//                             </div>
//                         </div>
//                         {/* </div> */}

//                         {/* <div className="row"> */}
//                         {renderDynamicLicenseFields()}

//                         {/* <div className="col-md-6">
//                             <div className="form-group mb-3">
//                                 <label htmlFor="selling_price" style={{ fontSize: "13px" }} className="form-label">{getPriceLabel("Selling Price")}

//                                     :</label>
//                                 <input
//                                     style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                     type="number"
//                                     name="selling_price"
//                                     id="selling_price"
//                                     className={`form-control ${errors.selling_price ? 'is-invalid' : ''}`}
//                                     value={formData.selling_price}
//                                     onChange={handleChange}

//                                 />
//                                 {errors.selling_price && <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.selling_price}</div>}

//                             </div>
//                         </div>
//                         <div className="col-md-6">
//                             <div className="form-group mb-3">
//                                 <label style={{ fontSize: "13px" }} htmlFor="min_selling_price" className="form-label">{getPriceLabel("Min Selling Price")}:</label>
//                                 <input
//                                     style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                     type="number"
//                                     name="min_selling_price"
//                                     value={formData.min_selling_price}
//                                     className={`form-control ${errors.min_selling_price ? 'is-invalid' : ''}`}

//                                     onChange={handleChange}

//                                 />
//                                 {errors.min_selling_price && <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.min_selling_price}</div>}

//                             </div>
//                         </div> */}


//                         <div className="col-md-6">
//                             <div className="form-group mb-3">
//                                 <label style={{ fontSize: "13px" }} htmlFor="description" className="form-label">Description :</label>
//                                 <textarea
//                                     style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                     name="description"
//                                     value={formData.description}
//                                     className="form-control"

//                                     onChange={handleChange}
//                                 />

//                             </div>
//                         </div>
//                     </div>
//                     <br />


//                 </form>
//             </Offcanvas.Body>

//             <div className="p-3 border-top  d-flex justify-content-end">
//                 <button type="button" className="btn btn-secondary me-2" onClick={handleClose}>
//                     Close
//                 </button>
//                 <button type="button" className="btn btn-primary" onClick={handleSubmit}>
//                     Save
//                 </button>
//             </div>
//         </Offcanvas>
//     );
// };

// export default ProductForm;


import React, { useState, useEffect } from 'react';
import { Modal, Offcanvas } from 'react-bootstrap';
import Select from 'react-select';

const ProductForm = ({
    showModal,
    handleClose,
    productId,
    productData,
    addProduct,
    vendors,
    fetchVendors,
    fetchBrands,
    editProduct,
    fetchCategories,
    setupIdError,
    products,
    categories,
    brands,
}) => {
    const [formData, setFormData] = useState({
        product_type: 'single',
        product_name: '',
        product_sku: '',
        alert_quantity: '',
        product_image: '',
        purchase_price: '',
        selling_price: '',
        min_selling_price: '',
        price_of_other_currency: '',
        tax: '',
        tax_type: '',
        category_id: '',
        subcategory_id: '',
        unit: '',
        brand_id: '',
        hourly_rate: '',
        inhouse: '',
        vendor_id: '',
        description: '',
        revenue_type: 'deferred',
        is_default_channel: false,
         default_channels: {}, 
    });

    const [vendorCurrency, setVendorCurrency] = useState("AED");
    const [loadingBrands, setLoadingBrands] = useState(false);
    const [loadingVendors, setLoadingVendors] = useState(false);
    const [loadingCategories, setLoadingCategories] = useState(false);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [showDeploymentCost, setShowDeploymentCost] = useState(false);

    const exchangeRate = parseFloat(localStorage.getItem('exchange_rate') || 3.672);
    const AED_TO_USD = 1 / exchangeRate;
    const USD_TO_AED = exchangeRate;

    const convertToUSD = (value) => (value * AED_TO_USD).toFixed(2);
    const convertToAED = (value) => (value * USD_TO_AED).toFixed(2);

    const getConvertedPrice = (fieldValue) => {
        if (formData.inhouse === "1") {
            return fieldValue;
        }
        if (formData.inhouse === "0" && vendorCurrency === "USD") {
            return convertToUSD(fieldValue);
        }
        return fieldValue;
    };

    const getPriceLabel = (fieldName) => {
        if (formData.inhouse === "1") {
            return `${fieldName} (AED)`;
        }
        if (formData.inhouse === "0" && vendorCurrency) {
            return `${fieldName} (${vendorCurrency})`;
        }
        return `${fieldName}`;
    };

    // Form field styles
    const fieldStyles = {
        fontSize: '13px',
        borderRadius: '12px',
        height: '38px',
        border: '1px solid #ddd'
    };

    const labelStyles = {
        fontSize: '13px',
        fontWeight: '500',
        marginBottom: '6px',
        color: '#333'
    };

    const sectionHeaderStyles = {
        fontSize: '15px',
        fontWeight: '600',
        color: '#62809fff',
        marginBottom: '15px',
        paddingBottom: '8px',
        borderBottom: '2px solid #e5e7e8ff'
    };

    useEffect(() => {
        if (showModal) {
            if (!loadingCategories && categories.allCategoriesList.length === 0) {
                setLoadingCategories(true);
                fetchCategories().finally(() => setLoadingCategories(false));
            }
            if (!loadingBrands && brands.allBrands.length === 0) {
                setLoadingBrands(true);
                fetchBrands().finally(() => setLoadingBrands(false));
            }
            if (!loadingVendors && vendors.allVendors.length === 0) {
                setLoadingVendors(true);
                fetchVendors().finally(() => setLoadingVendors(false));
            }
        }
    }, [showModal, categories.allCategoriesList.length, brands.allBrands.length, vendors.allVendors.length]);

    useEffect(() => {
        if (showModal) {
            if (productData) {
                const pricingsData = productData.Data?.pricings || productData.pricings || [];
                let categoriesData = productData.Data?.categories || productData.categories || [];
                
                // Fallback: derive categories from pricings license models or category_id if categories array is empty
                if ((!categoriesData || categoriesData.length === 0) && categories.allCategoriesList?.length > 0) {
                    if (Array.isArray(pricingsData) && pricingsData.length > 0) {
                        const pricingModels = pricingsData.map(pr => pr.license_model?.toLowerCase().trim());
                        categoriesData = categories.allCategoriesList.filter(cat => 
                            pricingModels.includes(cat.name?.toLowerCase().trim())
                        );
                    } else if (productData.category_id) {
                        const catIds = Array.isArray(productData.category_id) ? productData.category_id : [productData.category_id];
                        categoriesData = categories.allCategoriesList.filter(cat => catIds.includes(cat.id));
                    }
                }

                const selectedCategories = Array.isArray(categoriesData)
                    ? categoriesData.map(cat => ({
                        value: cat.id,
                        label: cat.name,
                    }))
                    : [];

                const dynamicPricingFields = {};
                if (Array.isArray(pricingsData)) {
                    pricingsData.forEach(price => {
                        const model = price.license_model?.toLowerCase();
                        if (model) {
                            dynamicPricingFields[`${model}_price`] = price.price || '';
                            dynamicPricingFields[`${model}_deployment_cost`] = price.deployment_cost || '';
                            dynamicPricingFields[`${model}_min_price`] = price.min_price || '';
                        }
                    });
                }
                const defaultChannels = {};
                if (Array.isArray(pricingsData)) {
                    pricingsData.forEach(price => {
                        const model = price.license_model?.toLowerCase().trim();
                        if (model) {
                            defaultChannels[model] = price.is_default_channel === true || price.is_default_channel === 'true' || price.is_default_channel === 1 || price.is_default_channel === '1';
                        }
                    });
                }

                setFormData({
                    product_name: productData.Data?.product_name || productData.product_name || '',
                    product_type: productData.Data?.product_type || productData.product_type || 'single',
                    product_sku: productData.Data?.product_sku || productData.product_sku || '',
                    alert_quantity: productData.Data?.alert_quantity || productData.alert_quantity || '',
                    product_image: productData.Data?.product_image || productData.product_image || '',
                    purchase_price: productData.Data?.purchase_price || productData.purchase_price || '',
                    selling_price: productData.Data?.selling_price || productData.selling_price || '',
                    min_selling_price: productData.Data?.min_selling_price || productData.min_selling_price || '',
                    price_of_other_currency: productData.Data?.price_of_other_currency || productData.price_of_other_currency || '',
                    tax: productData.Data?.tax || productData.tax || '',
                    tax_type: productData.Data?.tax_type || productData.tax_type || '',
                    category_id: selectedCategories.map(cat => cat.value),
                    subcategory_id: productData.Data?.subcategory_id || productData.subcategory_id || '',
                    unit: productData.Data?.unit || productData.unit || '',
                    brand_id: productData.Data?.brand_id || productData.brand_id || '',
                    hourly_rate: productData.Data?.hourly_rate || productData.hourly_rate || '',
                    inhouse: productData.Data?.inhouse || productData.inhouse || '',
                    vendor_id: productData.Data?.vendor_id || productData.vendor_id || '',
                    description: productData.Data?.description || productData.description || '',
                    revenue_type: productData.Data?.revenue_type || productData.revenue_type || '',
                    is_default_channel: productData?.is_default_channel || '',
                    deployment_description: productData?.deployment_description || '',
                    license_type:productData?.license_type||'',
                    default_channels: defaultChannels,
                    product_currency: productData.Data?.currency || productData.currency || productData.Data?.product_currency || productData.product_currency || 'AED',
                    ...dynamicPricingFields,
                });


                const vendorId = productData.Data?.vendor_id || productData.vendor_id;
                const inhouse = productData.Data?.inhouse || productData.inhouse;
                if (inhouse === '0' && vendorId) {
                    const selectedVendor = vendors.allVendors.find(
                        vendor => String(vendor.id) === String(vendorId)
                    );
                    if (selectedVendor) setVendorCurrency(selectedVendor.currency);
                }
                // Auto enable deployment cost toggle if any cost exists
                const hasDeploymentCost = Object.keys(dynamicPricingFields).some(key =>
                    key.includes("deployment_cost") && dynamicPricingFields[key] !== ""
                );
                setShowDeploymentCost(hasDeploymentCost);

            } else {
                setFormData({
                    product_type: 'single',
                    product_name: '',
                    product_sku: '',
                    alert_quantity: '',
                    product_image: '',
                    purchase_price: '',
                    selling_price: '',
                    min_selling_price: '',
                    price_of_other_currency: '',
                    tax: '',
                    tax_type: '',
                    category_id: [],
                    subcategory_id: '',
                    unit: '',
                    brand_id: '',
                    hourly_rate: '',
                    inhouse: '',
                    vendor_id: '',
                    description: '',
                    revenue_type: 'deferred',
                    is_default_channel: false,
                    deployment_description: '',
                    default_channels: {}, 
                    product_currency: 'AED',
                });

                setVendorCurrency('');
            }
        }
    }, [showModal, productData, vendors, categories.allCategoriesList]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "product_type") {
            setFormData((prevState) => ({
                ...prevState,
                product_type: value,
                revenue_type: value === 'single' ? 'deferred' : 'immediate'
            }));
            return;
        }

        if (name === "vendor_id") {
            const selectedVendor = vendors.allVendors.find(
                (vendor) => String(vendor.id) === String(value)
            );
            const newCurrency = selectedVendor ? selectedVendor.currency : "AED";

            setFormData((prevState) => {
                let updatedData = { ...prevState, vendor_id: value };
                if (selectedVendor) {
                    updatedData.vendor_name = selectedVendor.name;
                }
                if (vendorCurrency !== newCurrency) {
                    if (vendorCurrency === "AED" && newCurrency === "USD") {
                        updatedData.purchase_price = convertToUSD(prevState.purchase_price);
                        updatedData.selling_price = convertToUSD(prevState.selling_price);
                        updatedData.min_selling_price = convertToUSD(prevState.min_selling_price);
                    } else if (vendorCurrency === "USD" && newCurrency === "AED") {
                        updatedData.purchase_price = convertToAED(prevState.purchase_price);
                        updatedData.selling_price = convertToAED(prevState.selling_price);
                        updatedData.min_selling_price = convertToAED(prevState.min_selling_price);
                    }
                }
                return updatedData;
            });
            setVendorCurrency(newCurrency);
        } else {
            setFormData((prevState) => ({
                ...prevState,
                [name]: value,
            }));
        }
    };

    const handleCategoryChange = (selectedOptions) => {
        const selectedIds = selectedOptions ? selectedOptions.map((opt) => opt.value) : [];
        const selectedLabels = selectedOptions ? selectedOptions.map((opt) => opt.label.toLowerCase()) : [];

        let product_type = "single";
        let revenue_type = "deferred";

        if (selectedLabels.includes("perpetual")) {
            product_type = "single";
            revenue_type = "deffered";
        } else if (selectedLabels.includes("subscription") || selectedLabels.includes("hybrid")) {
            product_type = "single";
            revenue_type = "deferred";
        }

        setFormData((prev) => ({
            ...prev,
            category_id: selectedIds,
            product_type,
            revenue_type,
        }));
    };

    const renderDynamicLicenseFields = () => {
        const selectedCategories = categories?.allCategoriesList?.filter(
            (cat) => Array.isArray(formData.category_id) && formData.category_id.includes(cat.id)
        ) || [];

        if (selectedCategories.length === 0) return null;

        return (
            <div className="row mt-3">
                <div className="col-12">
                    <div className="d-flex justify-content-between align-items-center mb-2" style={{ borderBottom: '1.5px solid #eee', paddingBottom: '8px' }}>
                        <h6 style={{ ...sectionHeaderStyles, margin: 0 }}>
                            Pricing
                        </h6>
                        <div className="d-flex align-items-center">
                            <label style={{ ...labelStyles, margin: '0 10px 0 0' }}>Currency:</label>
                            <select
                                name="product_currency"
                                value={formData.product_currency || 'AED'}
                                onChange={handleChange}
                                className="form-select form-select-sm"
                                style={{ width: '80px', fontSize: '12px', borderRadius: '4px' }}
                            >
                                <option value="AED">AED</option>
                                <option value="USD">USD</option>
                            </select>
                        </div>
                    </div>
                </div>

                {selectedCategories.map((cat) => {
                    const model = cat.name?.toLowerCase().trim();
                     const isDefault = formData.default_channels?.[model] || false;
                    return (
                        <React.Fragment key={`${cat.id}-${model}`}>
                            <div className="col-md-4">
                                <div className="form-group mb-3">
                                    <label style={labelStyles}>{model} Price</label>
                                    <input
                                        type="number"
                                        name={`${model}_price`}
                                        value={formData[`${model}_price`] || ""}
                                        onChange={handleChange}
                                        className="form-control"
                                        style={fieldStyles}
                                        placeholder="0.00"
                                    />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group mb-3">
                                    <label style={labelStyles}>Min {model} Price</label>
                                    <input
                                        type="number"
                                        name={`${model}_min_price`}
                                        value={formData[`${model}_min_price`] || ""}
                                        onChange={handleChange}
                                        className="form-control"
                                        style={fieldStyles}
                                        placeholder="0.00"
                                    />
                                </div>
                            </div>
                            {showDeploymentCost && (
                                <div className="col-md-4">
                                    <div className="form-group mb-3">
                                        <label style={labelStyles}>{model} Deployment Cost</label>
                                        <input
                                            type="number"
                                            name={`${model}_deployment_cost`}
                                            value={formData[`${model}_deployment_cost`] || ""}
                                            onChange={handleChange}
                                            className="form-control"
                                            style={fieldStyles}
                                            placeholder="0.00"
                                        />
                                    </div>
                                </div>
                            )}
                             <div className="col-md-12">
                                <div className="form-check mb-3">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id={`default_channel_${model}`}
                                        checked={isDefault}
                                        onChange={(e) => {
                                            const checked = e.target.checked;
                                            setFormData((prev) => ({
                                                ...prev,
                                                default_channels: {
                                                    ...prev.default_channels,
                                                    [model]: checked,
                                                },
                                            }));
                                        }}
                                    />
                                    <label
                                        className="form-check-label"
                                        htmlFor={`default_channel_${model}`}
                                        style={{ fontSize: "13px" }}
                                    >
                                        Set as Default 
                                    </label>
                                </div>
                            </div>
                        </React.Fragment>
                    );
                })}
            </div>
        );
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.product_name) newErrors.product_name = 'Product name is required';
        
        return newErrors;
    };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setLoading(true);

//         const validationErrors = validateForm();
//         if (Object.keys(validationErrors).length > 0) {
//             setErrors(validationErrors);
//             setLoading(false);
//             return;
//         }

//         const dataToSend = { ...formData };
//         if (!Array.isArray(dataToSend.category_id)) {
//             dataToSend.category_id = dataToSend.category_id ? [Number(dataToSend.category_id)] : [];
//         }
//         dataToSend.category_id = dataToSend.category_id || [];

//         const selectedCategories = categories?.allCategoriesList?.filter(cat =>
//             dataToSend.category_id.includes(cat.id)
//         ) || [];

//         // dataToSend.pricings = selectedCategories.map(cat => {
//         //     const model = cat.name.toLowerCase();
//         //     return {
//         //         license_model: model,
//         //         price: Number(formData[`${model}_price`] || 0),
//         //         deployment_cost: Number(formData[`${model}_deployment_cost`] || 0),
//         //         min_price: Number(formData[`${model}_min_price`] || 0),
//         //         deployment_description: formData.deployment_description || '',
//         //         is_default_channel: formData.default_channels?.[model] || false,
//         //     };
//         // });
//         dataToSend.pricings = selectedCategories.map((cat, index) => {
//     const model = cat.name.toLowerCase();
//     const isDefault =
//         formData.default_channels?.[model] ||
//         (formData.is_default_channel && index === 0); // fallback for single type

//     return {
//         license_model: model,
//         price: Number(formData[`${model}_price`] || 0),
//         deployment_cost: Number(formData[`${model}_deployment_cost`] || 0),
//         min_price: Number(formData[`${model}_min_price`] || 0),
//         deployment_description: formData.deployment_description || '',
//         is_default_channel: isDefault,
//     };
// });
// console.log("Data Sent to Backend:", dataToSend.pricings);



//         selectedCategories.forEach(cat => {
//             const model = cat.name.toLowerCase();
//             delete dataToSend[`${model}_price`];
//             delete dataToSend[`${model}_deployment_cost`];
//             delete dataToSend[`${model}_min_price`];
//         });

//         let apierrors;
//         try {
//             if (productData) {
//                 apierrors = await editProduct(productData.id, dataToSend);
//             } else {
//                 apierrors = await addProduct(dataToSend);
//             }
//         } catch (err) {
//             console.error(err);
//             setLoading(false);
//             return;
//         }

//         if (apierrors) {
//             setErrors(apierrors);
//         } else {
//             setErrors({});
//             handleClose();
//         }
//         setLoading(false);
//     };

    // Custom styles for react-select to fix selected items display
    
      const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
        setErrors(validationErrors);
        setLoading(false);
        return;
    }

    const dataToSend = { ...formData };
    dataToSend.currency = formData.product_currency || formData.currency || 'AED';
    dataToSend.product_currency = formData.product_currency || formData.currency || 'AED';
    if (!Array.isArray(dataToSend.category_id)) {
        dataToSend.category_id = dataToSend.category_id ? [Number(dataToSend.category_id)] : [];
    }
    dataToSend.category_id = dataToSend.category_id || [];

    const selectedCategories = categories?.allCategoriesList?.filter(cat =>
        dataToSend.category_id.includes(cat.id)
    ) || [];

    // FIXED: Debug the default_channels state
    console.log("Current default_channels:", formData.default_channels);
    
    dataToSend.pricings = selectedCategories.map((cat) => {
        const model = cat.name.toLowerCase().trim();
        const isDefault = Boolean(formData.default_channels?.[model]);
        
        console.log(`Processing ${model}: isDefault =`, isDefault, "from", formData.default_channels?.[model]);
        
        return {
            license_model: model,
            price: Number(formData[`${model}_price`] || 0),
            deployment_cost: Number(formData[`${model}_deployment_cost`] || 0),
            min_price: Number(formData[`${model}_min_price`] || 0),
            deployment_description: formData.deployment_description || '',
            is_default_channel: isDefault,
            product_currency: formData.product_currency || 'AED',
        };

    });

    console.log("Final Data Sent to Backend:", JSON.stringify(dataToSend.pricings, null, 2));

    // Clean up dynamic pricing fields
    selectedCategories.forEach(cat => {
        const model = cat.name.toLowerCase().trim();
        delete dataToSend[`${model}_price`];
        delete dataToSend[`${model}_deployment_cost`];
        delete dataToSend[`${model}_min_price`];
    });

    let apierrors;
    try {
        if (productData) {
            apierrors = await editProduct(productData.id, dataToSend);
        } else {
            apierrors = await addProduct(dataToSend);
        }
    } catch (err) {
        console.error(err);
        setLoading(false);
        return;
    }

    if (apierrors) {
        setErrors(apierrors);
    } else {
        setErrors({});
        handleClose();
    }
    setLoading(false);
};
    const customSelectStyles = {
        control: (provided, state) => ({
            ...provided,
            fontSize: '13px',
            borderRadius: '6px',
            minHeight: '38px',
            border: '1px solid #ddd',
            boxShadow: 'none',
            '&:hover': {
                border: '1px solid #aaa'
            }
        }),
        multiValue: (provided) => ({
            ...provided,
            backgroundColor: '#e9ecef',
            borderRadius: '4px',
            fontSize: '12px'
        }),
        multiValueLabel: (provided) => ({
            ...provided,
            color: '#495057',
            fontSize: '12px',
            padding: '2px 6px'
        }),
        multiValueRemove: (provided) => ({
            ...provided,
            borderRadius: '0 4px 4px 0',
            '&:hover': {
                backgroundColor: '#dc3545',
                color: 'white'
            }
        }),
        valueContainer: (provided) => ({
            ...provided,
            padding: '2px 8px',
            minHeight: '38px'
        }),
        input: (provided) => ({
            ...provided,
            margin: '0',
            padding: '0'
        }),
        placeholder: (provided) => ({
            ...provided,
            fontSize: '13px',
            color: '#6c757d'
        })
    };

    return (
        <>
         <div>
  {showModal && (
    <div
      className="project-modal-backdrop"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.2)', // light white transparent
        zIndex: 1048, // ✅ keep it below the modal backdrop (Bootstrap's 1050)
        pointerEvents: 'none', // ✅ prevent blocking modal clicks
        backdropFilter: 'blur(2px)',
        WebkitBackdropFilter: 'blur(2px)',
        transition: 'opacity 0.3s ease',
      }}
    />
  )}
</div>
        <Offcanvas show={showModal} onHide={handleClose} placement='end' style={{ width: '850px' }}>
            <Offcanvas.Header closeButton style={{ borderBottom: '1px solid #dee2e6' }}>
                <Offcanvas.Title style={{ fontSize: '16px', fontWeight: '600' }}>
                    {productId ? 'Edit Product' : 'Add New Product'}
                </Offcanvas.Title>
            </Offcanvas.Header>

            <Offcanvas.Body style={{ padding: '20px' }}>
                <form>
                    {/* Basic Information Section */}
                    <div className="row mb-4">
                        <div className="col-12">
                            <h6 style={sectionHeaderStyles}>
                                Basic Information
                            </h6>
                        </div>

                        <div className="col-md-6">
                            <div className="form-group mb-3">
                                <label style={labelStyles}>Product Name *</label>
                                <input
                                    type="text"
                                    name="product_name"
                                    className={`form-control ${errors.product_name ? 'is-invalid' : ''}`}
                                    value={formData.product_name}
                                    onChange={handleChange}
                                    style={fieldStyles}
                                    placeholder="Enter product name"


                                />
                                {errors.product_name && <div className="invalid-feedback" style={{ fontSize: '12px' }}>{errors.product_name}</div>}
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="form-group mb-3">
                                <label style={labelStyles}>Description</label>
                                <textarea
                                    name="description"
                                    value={formData.description}
                                    className="form-control"
                                    onChange={handleChange}
                                    style={{ ...fieldStyles, height: '38px', minHeight: '38px', resize: 'vertical' }}
                                    placeholder="Product description"
                                    rows="1"
                                />
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="form-group mb-3">
                                <label style={labelStyles}>Brand</label>
                                <select
                                    name="brand_id"
                                    value={formData.brand_id}
                                    onChange={handleChange}
                                    className="form-control"
                                    style={fieldStyles}
                                >
                                    <option value="">Select Brand</option>
                                    {brands?.allBrands?.map((brand) => (
                                        <option key={brand.id} value={brand.id}>{brand.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="form-group mb-3">
                                <label style={labelStyles}>Type *</label>
                                <Select
                                    name="category_id"
                                    isMulti
                                    options={categories?.allCategoriesList?.map((cat) => ({
                                        value: cat.id,
                                        label: cat.name,
                                    })) || []}
                                    value={categories?.allCategoriesList
                                        ?.filter(cat => formData.category_id?.includes(cat.id))
                                        .map(cat => ({ value: cat.id, label: cat.name })) || []}
                                    onChange={handleCategoryChange}
                                    styles={customSelectStyles}
                                    placeholder="Select types"
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group mb-3">
                                <label style={labelStyles}>Category</label>
                                <select
                                    name="license_type"
                                    className='form-control'
                                    value={formData.license_type}
                                    onChange={handleChange}
                                    style={fieldStyles}
                                >
                                    <option value="">Select Category</option>
                                    <option value='license'>License</option>
                                    <option value='service'>Service</option>
                                </select>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="form-group mb-3">
                                <label style={labelStyles}>Unit</label>
                                <select
                                    name="unit"
                                    className='form-control'
                                    value={formData.unit}
                                    onChange={handleChange}
                                    style={fieldStyles}
                                >
                                    <option value="">Select Unit</option>
                                    <option value="qty">QTY</option>
                                    <option value="man-days">MAN-DAYS</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="form-group mb-3">
                                <label style={labelStyles}>Deployment Description</label>
                                <textarea
                                    name="deployment_description"
                                    value={formData.deployment_description || ""}
                                    onChange={handleChange}
                                    className="form-control"
                                    style={{ ...fieldStyles, height: '60px', resize: 'vertical' }}
                                    placeholder="Enter deployment description"
                                    rows="2"
                                />
                            </div>
                        </div>

                    </div>

                    {/* Product Details Section */}
                    <div className="row mb-4">
                        <div className="col-12">
                            <h6 style={sectionHeaderStyles}>
                                Product Details
                            </h6>
                        </div>

                        <div className="col-md-4">
                            <div className="form-group mb-3">
                                <label style={labelStyles}>Product SKU</label>
                                <input
                                    type="text"
                                    name="product_sku"
                                    className="form-control"
                                    value={formData.product_sku}
                                    onChange={handleChange}
                                    style={fieldStyles}
                                    placeholder="SKU code"
                                />
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="form-group mb-3">
                                <label style={labelStyles}>Alert Quantity</label>
                                <input
                                    type="text"
                                    name="alert_quantity"
                                    className="form-control"
                                    value={formData.alert_quantity}
                                    onChange={handleChange}
                                    style={fieldStyles}
                                    placeholder="0"
                                />
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="form-group mb-3">
                                <label style={labelStyles}>Product Source *</label>
                                <select
                                    name="inhouse"
                                    className={`form-control ${errors.inhouse ? 'is-invalid' : ''}`}
                                    value={formData.inhouse}
                                    onChange={handleChange}
                                    style={fieldStyles}
                                >
                                    <option value="">Select Source</option>
                                    <option value='1'>Inhouse</option>
                                    <option value='0'>Outsource</option>
                                </select>
                                {errors.inhouse && <div className="invalid-feedback" style={{ fontSize: '12px' }}>{errors.inhouse}</div>}
                            </div>
                        </div>

                        {formData.inhouse === '0' && (
                            <div className="col-md-6">
                                <div className="form-group mb-3">
                                    <label style={labelStyles}>Vendor</label>
                                    <select
                                        name="vendor_id"
                                        className="form-control"
                                        value={formData.vendor_id}
                                        onChange={handleChange}
                                        style={fieldStyles}
                                    >
                                        <option value="">Select Vendor</option>
                                        {vendors?.allVendors?.map((vendor) => (
                                            <option key={vendor.id} value={vendor.id}>{vendor.name}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        )}
                     
                        <div className="col-md-6">
                            <div className="form-group mb-3">
                                <label style={labelStyles} htmlFor="deploymentCostToggle">Show Deployment Cost</label>

                                <div className="form-check form-switch">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                        id="deploymentCostToggle"
                                        checked={showDeploymentCost}
                                        onChange={(e) => setShowDeploymentCost(e.target.checked)}
                                    />

                                </div>
                            </div>
                        </div>

                    </div>

                    {/* Pricing Section */}
                    <div className="row mb-4">
                        <div className="col-12">
                            <h6 style={sectionHeaderStyles}>
                                Basic Pricing
                            </h6>
                        </div>

                        <div className="col-md-4">
                            <div className="form-group mb-3">
                                <label style={labelStyles}>Purchase Price *</label>
                                <input
                                    type="number"
                                    name="purchase_price"
                                    className={`form-control ${errors.purchase_price ? 'is-invalid' : ''}`}
                                    value={formData.purchase_price}
                                    onChange={handleChange}
                                    style={fieldStyles}
                                    placeholder="0.00"
                                />
                                {errors.purchase_price && <div className="invalid-feedback" style={{ fontSize: '12px' }}>{errors.purchase_price}</div>}
                            </div>
                        </div>

                        {/* <div className="col-md-4">
                            <div className="form-group mb-3">
                                <label style={labelStyles}>Selling Price *</label>
                                <input
                                    type="number"
                                    name="selling_price"
                                    className={`form-control ${errors.selling_price ? 'is-invalid' : ''}`}
                                    value={formData.selling_price}
                                    onChange={handleChange}
                                    style={fieldStyles}
                                    placeholder="0.00"
                                />
                                {errors.selling_price && <div className="invalid-feedback" style={{ fontSize: '12px' }}>{errors.selling_price}</div>}
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="form-group mb-3">
                                <label style={labelStyles}>Min Selling Price *</label>
                                <input
                                    type="number"
                                    name="min_selling_price"
                                    className={`form-control ${errors.min_selling_price ? 'is-invalid' : ''}`}
                                    value={formData.min_selling_price}
                                    onChange={handleChange}
                                    style={fieldStyles}
                                    placeholder="0.00"
                                />
                                {errors.min_selling_price && <div className="invalid-feedback" style={{ fontSize: '12px' }}>{errors.min_selling_price}</div>}
                            </div>
                        </div> */}
                    </div>

                    {/* Dynamic License Pricing */}
                    {renderDynamicLicenseFields()}
                </form>
            </Offcanvas.Body>

            <div className="p-3 border-top d-flex justify-content-end" style={{ backgroundColor: '#f8f9fa' }}>
                <button type="button" className="btn btn-outline-secondary me-2" onClick={handleClose} style={{ minWidth: '80px' }}>
                    Cancel
                </button>
                <button type="button" className="btn btn-primary" onClick={handleSubmit} disabled={loading} style={{ minWidth: '80px' }}>
                    {loading ? 'Saving...' : 'Save Product'}
                </button>
            </div>
        </Offcanvas>
        </>
    );
};

export default ProductForm;
